import React from "react";
import "./HeaderMobile.css";
import HeaderTitleMobile from "../headerTitleMobile/HeaderTitleMobile";

export default function HeaderMobile() {
  return (
    <div className="headerMobile">
      <HeaderTitleMobile />
    </div>
  );
}
